import * as types from '../actions/actionTypes';

const initialState = {
  visible: false,
  message: '',
  error: '',
  title: "",
  inline: false,
  newStyles: false,
  buttons: [],
  click: null,
  // type: null, // added for look // not used
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.CHANGE_MESSAGE_BOX:
      return Object.assign({}, state, {
        ...action.payload
      });

  }

  return state;

}
